<template>
  <div class="container">
    <form method="post" @submit.prevent="submit">
      <div class="mb-5 mt-5 d-flex justify-content-center">
        <div class="card card-authenticate w-100">
          <div class="card-header">
            <h1 class="m-0">
              {{ $t('phrase.extend_licence') }}
            </h1>
          </div>
          <div class="card-body">
            <p>
              Welkom bij onze licentieverlengingsoptie. Met deze functie kun je de licentie van
              jouw organisatie met 1 jaar verlengen voor € 500,-. Door de licentie te
              verlengen, behoud je toegang tot alle functies en voordelen die onze software biedt,
              inclusief een publieke pagina op ons platform waarop jouw bedrijf zich kan profileren.
            </p>

            <p class="m-0">
              Als je vragen hebt over de licentieverlenging of andere functies van onze software,
              neem dan gerust contact met ons op. Ons team helpt je graag verder. Bedankt dat je
              voor onze software hebt gekozen en we kijken ernaar uit om jou en jouw organisatie
              te blijven ondersteunen!
            </p>
          </div>
          <div class="card-footer">
            <label class="mb-3">
              <input
                id="register-accept-terms"
                v-model="acceptTerms"
                class="mr-2"
                type="checkbox"
                required="required"
              />
              <span v-html="$t('sentence.accept_price_year_licence', { totalPrice: 500 })"></span>
            </label>

            <v-button
              text="phrase.extend_licence"
              :block="true"
              type="submit"
              :loader="loader"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import { extendOrganisationLicence } from '@/organisation/api';
import { mapGetters } from 'vuex';

export default {
  name: 'LicenceExtension',
  components: {
    'v-button': Button,
  },
  data() {
    return {
      acceptTerms: false,
      loader: {
        loading: false,
      },
    };
  },
  computed: {
    ...mapGetters(['org']),
  },
  methods: {
    async submit() {
      this.loader.loading = true;
      const response = await extendOrganisationLicence(this.org.slug);
      if (response.status === 201) {
        await this.$router.push({
          name: 'success',
          query: {
            msg: 'sentence.extend_licence_success',
            next: 'organisation',
          },
        });
      }
    },
  },
};
</script>
